import siteInfo from "@/constants/siteInfo";
import dynamic from "next/dynamic";
//import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import SVG from "react-inlinesvg";
import { useEffect } from "react";
import sendGAEvent from "@/utils/gaEvent";
import NavLink from "../Navlink";
import { useAuth } from "@/context/AuthContext";
import { getDashboardUrl } from "@/utils/sso";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const MobileMenuSlider = dynamic(() => import("./MobileMenuSlider"));

const MobileNavbar = ({ header_menu = [] }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
  const [IsSubCategOpen, setIsSubCategOpen] = useState(false);
  const { user, login, logout, isAuthenticated } = useAuth();
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP =
    router?.asPath?.includes("/uttar-pradesh") &&
    !router.asPath.includes("board-results");
  const isDL = router?.asPath?.includes("/delhi");
  const isCGH = router?.asPath?.includes("/chhattisgarh");
  const isUK = router?.asPath?.includes("/uttarakhand");
  const isBiz = router?.asPath?.includes("/business");
  const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  const masterConfig = useContext(MasterConfigContext);
  const ssoKeys = masterConfig["SSO"];
  const liveKeys = masterConfig["livetv_page"];

  const handleSearch = () => {
    if (!searchText?.trim()?.length > 0) return;
    setIsDrawerOpen(false);
    setSearchText("");
    setIsSearchBoxOpen(false);
    let eventName = `view_search_results`;
    sendGAEvent({
      eventName: eventName,
      pageTitle: document?.title,
      pageLocation: window?.location?.href,
      searchQuery: searchText?.trim(),
    });
    window.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL
      }/search/${encodeURIComponent(searchText?.trim())}`;
    // setSearchText("");
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && searchText?.trim()?.length > 0) {
      setIsDrawerOpen(false);
      handleSearch();
      // Blur the input field to close the keyboard
      event.target.blur();
    }
  };

  useEffect(() => {
    if (isDrawerOpen) {
      // Prevent scrolling
      document.body.style.overflow = "hidden";
      let element = document.querySelectorAll(".vdo_floating");
      let element2 = document.querySelectorAll("#vdo_logo_parent");

      for (var i = 0; i < element.length; i++) {
        element[i].style.setProperty("z-index", "0", "important");
      }
      for (var i = 0; i < element2.length; i++) {
        element2[i].style.setProperty("display", "none", "important");
      }
    } else {
      // Re-enable scrolling
      document.body.style.overflow = "";
      let element = document.querySelectorAll(".vdo_floating");
      let element2 = document.querySelectorAll("#vdo_logo_parent");

      for (var i = 0; i < element.length; i++) {
        element[i].style.setProperty("z-index", "1", "important");
      }
      for (var i = 0; i < element2.length; i++) {
        element2[i].style.setProperty("display", "block", "important");
      }
    }

    // Cleanup function to re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerOpen]);
  // console.log(websiteUrl+(isMadhya?'/madhya-pradesh':isRajasthan?'/rajasthan':isUP?'/uttar-pradesh':isHR?'/haryana':isBH?'/bihar':isDL?'/delhi-news':'/'))
  return (
    <>
      <nav className={`w-full  top-0 z-50 bg-white shadow-md `}>
        <div className=" flex items-center justify-between px-2 py-1">
          <div className="flex items-center">
            <button
              className="min-w-[35px] text-gray-500 focus:outline-none"
              onClick={() => {
                let eventName = `TopBar-HamburgerMenu`;
                sendGAEvent({
                  eventName: eventName,
                  pageTitle: document?.title,
                  pageLocation: window?.location?.href,
                });
                setIsDrawerOpen(!isDrawerOpen);
              }}
            >
              <img
                className="min-w-[35px]"
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/menu.svg"
                alt="menu icon"
                width={35}
                height={35}
                loading="eager"
              />
            </button>
            <div className="ml-2">
              <a
                href={
                  websiteUrl +
                  (isMadhya
                    ? "/madhya-pradesh"
                    : isRajasthan
                      ? "/rajasthan"
                      : isUP
                        ? "/uttar-pradesh"
                        : isHR
                          ? "/haryana"
                          : isBH
                            ? "/bihar"
                            : isDL
                              ? "/delhi-news"
                              : isCGH
                                ? "/chhattisgarh"
                                : isUK
                                  ? "/uttarakhand"
                                  : isBiz
                                    ? "/business"
                                  : "/")
                }
                onClick={() => {
                  let eventName = `TopBar-LogoClick`;
                  sendGAEvent({
                    eventName: eventName,
                    pageTitle: document?.title,
                    pageLocation: window?.location?.href,
                  });
                  setIsDrawerOpen(false);
                }}
              >
                <img
                  src={
                    isDrawerOpen
                      ? siteInfo?.siteLogo
                      : isRajasthan
                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-2994.png"
                        : isMadhya
                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-3068.png"
                          : isHR
                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                            : isBH
                              ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                              : isUP
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                : isDL
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                  : isCGH
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ccg_logo.png"
                                    : isUK
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"
                                      : isBiz
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/biz-horizontal.svg"

                                        : siteInfo?.siteLogo
                  }
                  alt={
                    isMadhya
                      ? "MP Tak - Mobile"
                      : isRajasthan
                        ? "Rajasthan Tak - Mobile"
                        : isUP
                          ? "UP Tak - Mobile"
                          : isHR
                            ? "Haryana Tak - Mobile"
                            : isBH
                              ? "Bihar Tak - Mobile"
                              : isDL
                                ? "Delhi Tak - Mobile"
                                : isCGH
                                  ? "Chattisgarh Tak - Mobile"
                                  : isUK
                                    ? "Uttarakhand tak - Mobile"
                                    : siteInfo?.siteName + " - Mobile"
                  }
                  title={
                    isMadhya
                      ? "MP Tak"
                      : isRajasthan
                        ? "Rajasthan Tak"
                        : isUP
                          ? "UP Tak"
                          : isHR
                            ? "Haryana Tak"
                            : isBH
                              ? "Bihar Tak"
                              : isDL
                                ? "Delhi Tak"
                                : isCGH
                                  ? "Chattisgarh Tak"
                                  : isUK
                                    ? "Uttarakhand Tak"
                                    : siteInfo?.siteName
                  }
                  loading="eager"
                  fetchPriority="high"
                  height={isMadhya ? 30 : 37}
                  width={isUK ? 120 : 90}
                // className={`${isMadhya?' height-[30px] width-[auto]':'height-[35px]'}`}
                />
              </a>
            </div>
          </div>
          <div className="flex space-x-2 justify-end ml-auto">
            <NavLink
              exact={true}
              className={"text-primary"}
              href={liveKeys?.activeUrl || "/tak360-livetv"}
              title={""}
              onClick={() => {
                let eventName = `TopBar-ReadClick`;
                sendGAEvent({
                  eventName: eventName,
                  pageTitle: document?.title,
                  pageLocation: window?.location?.href,
                });
              }}
            >
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/Live-msite.svg"
                className=" mr-2"
                title="home"
              />
            </NavLink>
          </div>

          <div className="flex space-x-2 ml-2 max-w-[50%]">
            {/* Search Box */}
            <div className="flex items-center max-w-auto">
              {isSearchBoxOpen ? (
                <>
                  <div className="flex items-center">
                    <div className="relative">
                      <input
                        id="search"
                        className={` placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-1 pl-3 pr-10 shadow-sm focus:outline-none focus:border-red-300 focus:ring-red-300 focus:ring-1 sm:text-sm max-h-[40px]`}
                        placeholder="यहां खोज करें"
                        type="text"
                        name="search"
                        minLength={1}
                        value={searchText}
                        onKeyDown={handleKeyPress}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                      <div
                        role="button"
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                        onClick={() => handleSearch()}
                      >
                        <img
                          className="text-gray-500"
                          loading="eager"
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                          alt="Search Icon"
                          height={20}
                          width={20}
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setIsSearchBoxOpen(false)}
                    className="focus:outline-none rounded-sm p-1"
                  >
                    <span className="h-6 w-6 text-black">
                      <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/close.svg" />
                    </span>
                  </button>
                </>
              ) : (
                <button className="text-gray-700 focus:outline-none mr-4 md:hidden">
                  <img
                    loading="eager"
                    height={24}
                    width={24}
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                    alt="Search Icon"
                    onClick={() => {
                      let eventName = `TopBar-Search`;
                      sendGAEvent({
                        eventName: eventName,
                        pageTitle: document?.title,
                        pageLocation: window?.location?.href,
                      });
                      setIsSearchBoxOpen(true);
                    }}
                  />
                </button>
              )}
            </div>
          </div>
        </div>
        <MobileMenuSlider header_menu={header_menu} />
      </nav>
      {/* Drawer overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity ${isDrawerOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setIsDrawerOpen(false)}
      ></div>

      {/* Drawer menu */}
      <section >
        <div
          className={`fixed left-0 transform w-screen text-slate-700 shadow-xl bg-white transition-transform ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          style={{ zIndex: 101, top: 0, bottom: 120, overflowY: "auto" }}
        >
          <div
            className={`flex flex-col ${isMadhya
              ? "bg-[#0C8A70]"
              : isRajasthan
                ? "bg-[#FFA51A]"
                : isHR
                  ? "bg-[#EFF8EC]"
                  : isBH
                    ? "bg-[#FAEDF5]"
                    : isUP
                      ? "bg-[#feedeb]"
                      : isDL
                        ? "bg-[#fbd6d6]"
                        : isCGH
                          ? "bg-[#0C8A70]"
                          : isUK
                            ? "bg-[#05a1fa]"
                            : isBiz ? "bg-bizDark"
                              : "bg-primary"
              }`}
          >
            <div className="flex items-center justify-between">
              <div className="ml-2">
                <a
                  href={
                    websiteUrl +
                    (isMadhya
                      ? "/madhya-pradesh"
                      : isRajasthan
                        ? "/rajasthan"
                        : isUP
                          ? "/uttar-pradesh"
                          : isHR
                            ? "/haryana"
                            : isBH
                              ? "/bihar"
                              : isDL
                                ? "/delhi-news"
                                : isCGH
                                  ? "/chhattisgarh"
                                  : isUK
                                    ? "/uttarakhand"
                                    : isBiz
                                      ? "/business"
                                      : "/")
                  }
                  onClick={() => setIsDrawerOpen(false)}
                >
                  {isBiz ? <div className="ps-4 pt-2">  <svg xmlns="http://www.w3.org/2000/svg" width="106" height="33" viewBox="0 0 106 33" fill="none">
                    <path d="M105.925 19.6218C105.926 17.8003 105.53 16.0003 104.764 14.3475C103.998 12.6948 102.881 11.229 101.491 10.0524C100.1 8.87568 98.4701 8.0165 96.7135 7.53468C94.957 7.05286 93.1166 6.95997 91.3205 7.26257C90.2872 5.60313 88.922 4.17523 87.3107 3.06856C85.6994 1.96189 83.8767 1.20039 81.957 0.831752C80.0374 0.463111 78.0623 0.495327 76.1557 0.926428C74.2491 1.35753 72.4523 2.17816 70.8779 3.33684C68.853 1.77802 66.4858 0.72451 63.9724 0.263611C61.459 -0.197288 58.8719 -0.0522867 56.4258 0.686654C53.9796 1.42559 51.7449 2.73716 49.9069 4.51254C48.0689 6.28792 46.6807 8.47595 45.8573 10.8952C45.0339 13.3144 44.7992 15.8951 45.1724 18.4232C45.5457 20.9513 46.5163 23.354 48.0037 25.432C49.4911 27.51 51.4524 29.2034 53.7251 30.3717C55.9977 31.5401 58.5161 32.1497 61.0714 32.15C61.1703 32.15 61.2676 32.15 61.3649 32.15H61.4383H93.4538C96.7669 32.1338 99.9387 30.8061 102.276 28.4574C104.613 26.1087 105.925 22.9301 105.925 19.6167" fill="white" />
                    <path d="M68.3135 8.74402V12.325H63.2567V28.2295H58.7288V12.325H53.7266V8.74402H68.3135Z" fill="#3A98D4" />
                    <path d="M74.5528 14.1155C75.347 14.6111 75.9715 15.3368 76.3431 16.1962V13.5369H80.818V28.2313H76.3516V25.5754C75.981 26.4353 75.3563 27.1613 74.5613 27.6561C73.6877 28.1844 72.6804 28.4499 71.6599 28.4207C70.5105 28.4379 69.3807 28.122 68.407 27.511C67.4189 26.8706 66.6338 25.9618 66.1439 24.891C65.5898 23.7531 65.3128 22.4188 65.3128 20.8884C65.3128 19.3579 65.5898 18.0197 66.1439 16.8738C66.6365 15.8079 67.4212 14.9037 68.407 14.2658C69.3809 13.6554 70.5107 13.3399 71.6599 13.3577C72.6802 13.3287 73.6872 13.5936 74.5613 14.1207L74.5528 14.1155ZM70.7827 18.2546C70.1933 18.8885 69.8992 19.7664 69.9003 20.8884C69.9015 22.0103 70.1956 22.8883 70.7827 23.5221C71.3698 24.1536 72.1463 24.4694 73.1123 24.4694C73.5476 24.4834 73.9809 24.4038 74.3828 24.2359C74.7847 24.0681 75.1459 23.8159 75.4419 23.4964C76.0484 22.8455 76.3516 21.9762 76.3516 20.8884C76.3516 19.7823 76.0484 18.909 75.4419 18.2683C75.1436 17.9525 74.7818 17.7036 74.3802 17.538C73.9786 17.3723 73.5465 17.2937 73.1123 17.3074C72.1463 17.3074 71.3698 17.6231 70.7827 18.2546Z" fill="#3A98D4" />
                    <path d="M91.7718 28.2295L87.3754 21.9893V28.2295H82.8732V8.74402H87.3754V19.4341L91.9032 13.5352H97.1956L91.1403 20.8832L97.1956 28.2295H91.7718Z" fill="#3A98D4" />
                    <path d="M0.0128703 8.84148C0.794655 8.69542 1.58517 8.60066 2.37933 8.55787C3.38984 8.48912 4.42097 8.45391 5.47272 8.45219C6.56002 8.43403 7.64683 8.51084 8.72078 8.68167C9.52851 8.81943 10.3054 9.09963 11.0151 9.50923C11.6671 9.85848 12.2244 10.361 12.6391 10.9736C13.0704 11.6264 13.2917 12.3956 13.2732 13.1778C13.2728 14.012 13.0074 14.8245 12.5153 15.4981C11.9197 16.2811 11.101 16.8653 10.1669 17.1739V17.2435C11.1977 17.5186 12.1286 18.0821 12.8505 18.8677C13.5754 19.694 13.9547 20.7676 13.9099 21.8659C13.9242 22.6504 13.7416 23.426 13.3789 24.1218C13.0303 24.778 12.5503 25.3555 11.9688 25.8182C11.136 26.4279 10.1865 26.8596 9.17964 27.0866C7.6738 27.4267 6.13189 27.5809 4.58851 27.5455C3.52903 27.5455 2.61906 27.5171 1.85344 27.4552C1.08783 27.3933 0.469165 27.334 0 27.2644L0.0128703 8.84148ZM4.21474 16.0008H5.59129C6.72038 16.0008 7.57366 15.7894 8.15109 15.3666C8.42172 15.1841 8.64244 14.9369 8.79325 14.6474C8.94406 14.3579 9.02018 14.0353 9.01465 13.7089C9.01465 12.2497 8.01445 11.5209 6.01406 11.5227C5.54232 11.5227 5.17367 11.5227 4.903 11.5562C4.6712 11.5737 4.44112 11.6091 4.21474 11.6619V16.0008ZM4.21474 24.328C4.44855 24.3519 4.68347 24.363 4.91848 24.3615H5.83875C6.30721 24.364 6.77464 24.3173 7.23337 24.2223C7.64052 24.1391 8.02918 23.9828 8.38049 23.7609C8.70826 23.5534 8.98074 23.2693 9.17448 22.9332C9.38416 22.5498 9.48741 22.1172 9.47352 21.6803C9.47352 20.7196 9.10315 20.0381 8.36246 19.6359C7.52594 19.214 6.59737 19.0075 5.6609 19.0352H4.21474V24.328Z" fill="white" />
                    <path d="M20.914 8.59144H16.6426V27.3235H20.914V8.59144Z" fill="white" />
                    <path d="M23.4198 25.0317L32.352 12.1904V12.0847H24.2679V8.59144H37.8582V11.0251L29.1374 23.7272V23.8303H38V27.3235H23.4198V25.0317Z" fill="white" />
                  </svg></div>
                    : <img
                      src={
                        isDrawerOpen
                          ? isRajasthan
                            ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-2_rjtak.png"
                            : isMadhya
                              ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-2-mp.png"
                              : isHR
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                                : isBH
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                                  : isUP
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                    : isDL
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                      : isCGH
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/cgh_mobile_logo.png" //change
                                        : isUK
                                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"


                                          : siteInfo?.siteLogo2
                          : isRajasthan
                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-2994.png"
                            : isMadhya
                              ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-3068.png"
                              : isHR
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                                : isBH
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                                  : isUP
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                    : isDL
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                      : isCGH
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ccg_logo.png"
                                        : isUK
                                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"
                                          : isBiz ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/biz-horizontal.svg"

                                            : siteInfo?.siteLogo
                      }
                      alt={
                        isMadhya
                          ? "MP Tak"
                          : isRajasthan
                            ? "Rajasthan Tak"
                            : isUP
                              ? "UP Tak"
                              : isHR
                                ? "Haryana Tak"
                                : isBH
                                  ? "Bihar Tak"
                                  : isDL
                                    ? "Delhi Tak"
                                    : isCGH
                                      ? "Chhattisgarh Tak"
                                      : isUK
                                        ? "Uttarakhand Tak"
                                        : isBiz ? "Biz Tak"
                                          : siteInfo?.siteName
                      }
                      className="ps-4 pt-2"
                      title={
                        isMadhya
                          ? "MP Tak"
                          : isRajasthan
                            ? "Rajasthan Tak"
                            : isUP
                              ? "UP Tak"
                              : isHR
                                ? "Haryana Tak"
                                : isBH
                                  ? "Bihar Tak"
                                  : isDL
                                    ? "Delhi Tak"
                                    : isCGH
                                      ? "Chhattisgarh Tak"
                                      : isUK
                                        ? "Uttarakhand Tak"
                                        : isBiz ? "Biz Tak"
                                          : siteInfo?.siteName
                      }
                      loading="eager"
                      height={40}
                      width={130}
                    />}
                </a>
              </div>

              <button
                onClick={() => setIsDrawerOpen(false)}
                className="focus:outline-none rounded-sm p-2"
              >
                <span
                  className={`h-6 w-6 ${isDL || isUP || isBH || isHR || isUK
                    ? "text-black"
                    : "text-white"
                    }`}
                >
                  <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/close.svg" />
                </span>
              </button>
            </div>
            {ssoKeys?.showSignInButton ? (
              <div
                className={`my-2 ml-3 p-2 ${isDL || isUP || isBH || isHR || isUK
                  ? "text-black"
                  : "text-white"
                  }`}
              >
                {!isAuthenticated && (
                  <div onClick={login} className="flex items-center gap-1">
                    <SVG
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg"
                      className="w-8 h-8"
                    />
                    <button className="border-b ">Sign In</button>
                  </div>
                )}
                {isAuthenticated && (
                  <div className="flex items-center gap-1">
                    {user?.photo && (
                      <img
                        src={user?.photo || "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/authorDefault.png"}
                        alt="user"
                        className="w-12 h-12 rounded-full border border-primary"
                      />
                    )}
                    {!user?.photo && (
                      <SVG
                        src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg"
                        className="w-12 h-12"
                      />
                    )}
                    <div className="flex flex-col">
                      <a
                        href={getDashboardUrl(router?.asPath)}
                        className="font-semibold flex items-center gap-1"
                      >
                        {user?.givenName || "Guest"}
                        <SVG
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/edit.svg"
                          className="w-4 h-4"
                        />
                      </a>
                      <span onClick={logout} className="border-b w-fit">
                        Sign Out
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>

          <ul className="divide-y divide-gray-200 bg-white dark:divide-gray-800 rounded-t-xl pt-2 pb-6">
            <div className="flex my-2 mx-4 h-[40px]">
              <div className="flex items-center justify-center w-full">
                <div className="relative w-full">
                  <input
                    id="search"
                    className={` placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:border-primary-300 focus:ring-primary-300 focus:ring-1 sm:text-sm max-h-[40px]`}
                    placeholder="यहां खोज करें"
                    type="text"
                    name="search"
                    value={searchText}
                    onKeyDown={handleKeyPress}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <div
                    className="absolute inset-y-0 right-0 flex items-center pr-3"
                    onClick={() => handleSearch()}
                  >
                    <img
                      className="text-gray-500"
                      loading="eager"
                      height={20}
                      width={20}
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                      alt="Search Icon"
                    />
                  </div>
                </div>
              </div>
            </div>
            {header_menu?.map((item, index) => (
              <li
                key={index}
                id={item?.id}
                // className="hover:bg-primary-300 group    "
                className={`${isMadhya
                  ? "hover:bg-[#e2f8f4] group"
                  : isRajasthan
                    ? "hover:bg-[#faf2e7] group"
                    : isHR
                      ? "hover:bg-[#e8fce1] group"
                      : isBH
                        ? "hover:bg-[#ffe2f4] group"
                        : isUP
                          ? "hover:bg-[#feedeb] group"
                          : isDL
                            ? "hover:bg-[#fbd6d6] group"
                            : isCGH
                              ? "hover:bg-[#e0faf5] group"
                              : isUK
                                ? "hover:bg-[#e2f1fa] group"
                                : isBiz ? "hover:bg-bizLight group"
                                  : "hover:bg-primary-300 group"
                  }`}
                onClick={() => {
                  if (item?.sub_menu?.length > 0) {
                    setIsSubCategOpen(!IsSubCategOpen);
                  } else {
                    setIsDrawerOpen(false);
                  }
                }}
              >
                {item?.sub_menu?.length > 0 ? (
                  <div title={item?.title}>
                    <div
                      className={`flex items-center align-middle justify-between space-x-4 rtl:space-x-reverse border-l-4 border-l-white hover:border-l-4   py-2 px-4 
                    ${isMadhya
                          ? "hover:border-l-[#0C8A70]"
                          : isRajasthan
                            ? "hover:border-l-[#FFA51A]"
                            : isHR
                              ? "hover:border-l-[#EFF8EC]"
                              : isBH
                                ? "hover:border-l-[#f181c6]"
                                : isUP
                                  ? "hover:border-l-[#feedeb]"
                                  : isDL
                                    ? "hover:border-l-[#fbd6d6]"
                                    : isCGH
                                      ? "hover:border-l-[#0C8A70]"
                                      : isUK
                                        ? "hover:border-l-[#05a1fa]"
                                        : isBiz ? "hover:border-l-bizDark"
                                          : "hover:border-l-primary"
                        }`}
                    >
                      <p
                        onClick={() => {
                          let eventName = `HamburgerMenu - ${item?.title} Click`;
                          sendGAEvent({
                            eventName: eventName,
                            pageTitle: document?.title,
                            pageLocation: window?.location?.href,
                          });
                          setIsDrawerOpen(false);
                        }}
                        className={`text-lg font-bold truncatetext-white  ${isMadhya
                          ? "hover:bg-[#e2f8f4] group"
                          : isRajasthan
                            ? "hover:bg-[#faf2e7] group"
                            : isHR
                              ? "hover:bg-[#e8fce1] group"
                              : isBH
                                ? "hover:bg-[#ffe2f4] group"
                                : isUP
                                  ? "hover:bg-[#feedeb] group"
                                  : isDL
                                    ? "hover:bg-[#fbd6d6] group"
                                    : isCGH
                                      ? "hover:bg-[#e0faf5] group"
                                      : isUK
                                        ? "hover:bg-[#e2f1fa] group"
                                        : isBiz ? "hover:bg-bizLight group"
                                          : "hover:bg-primary-300 group"}`}
                        id={"dropdownHoverButton_" + index}
                        data-dropdown-toggle={"dropdownHover_" + index}
                      >
                        {item?.svg && (
                          <div className="w-4 h-4 inline mx-2">
                            <SVG className="w-4 h-4 inline" src={item?.svg} />
                          </div>
                        )}
                        <a href={websiteUrl + item?.canonical_url}>
                          {item?.title}
                        </a>
                      </p>
                      {item?.sub_menu?.length > 0 && (
                        <svg
                          className="w-2 h-2 ml-1"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 10 6"
                          onClick={() => setIsSubCategOpen(!IsSubCategOpen)}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m1 1 4 4 4-4"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ) : (
                  <a
                    onClick={() => {
                      let eventName = `HamburgerMenu - ${item?.title} Click`;
                      sendGAEvent({
                        eventName: eventName,
                        pageTitle: document?.title,
                        pageLocation: window?.location?.href,
                      });
                    }}
                    href={websiteUrl + item?.canonical_url}
                    title={item?.title}
                  >
                    <div className={`flex items-center align-middle justify-between space-x-4 rtl:space-x-reverse border-l-4 border-l-white hover:border-l-4   py-2 px-4 ${isMadhya
                      ? "hover:border-l-[#0C8A70]"
                      : isRajasthan
                        ? "hover:border-l-[#FFA51A]"
                        : isHR
                          ? "hover:border-l-[#EFF8EC]"
                          : isBH
                            ? "hover:border-l-[#f181c6]"
                            : isUP
                              ? "hover:border-l-[#feedeb]"
                              : isDL
                                ? "hover:border-l-[#fbd6d6]"
                                : isCGH
                                  ? "hover:border-l-[#0C8A70]"
                                  : isUK
                                    ? "hover:border-l-[#05a1fa]"
                                    : isBiz ? "hover:border-l-bizDark"
                                      : "hover:border-l-primary"
                      }`}>
                      <p
                        onClick={() => setIsDrawerOpen(false)}
                        className={`text-lg font-bold truncatetext-white ${isMadhya
                          ? "hover:bg-[#e2f8f4]  "
                          : isRajasthan
                            ? "hover:bg-[#faf2e7]  "
                            : isHR
                              ? "hover:bg-[#e8fce1]  "
                              : isBH
                                ? "hover:bg-[#ffe2f4]  "
                                : isUP
                                  ? "hover:bg-[#feedeb]  "
                                  : isDL
                                    ? "hover:bg-[#fbd6d6]  "
                                    : isCGH
                                      ? "hover:bg-[#e0faf5]  "
                                      : isUK
                                        ? "hover:bg-[#e2f1fa]  "
                                        : isBiz ? "hover:bg-bizDark"
                                          : "hover:bg-primary-300  "} `}
                        id={"dropdownHoverButton_" + index}
                        data-dropdown-toggle={"dropdownHover_" + index}
                      >
                        {item?.svg && (
                          <div className="w-4 h-4 inline mx-2">
                            <SVG className="w-4 h-4 inline" src={item?.svg} />
                          </div>
                        )}
                        {item?.title}
                      </p>
                    </div>
                  </a>
                )}

                {/* Dropdown menu */}
                {item?.sub_menu?.length > 0 && IsSubCategOpen && (
                  <div
                    id={"dropdownHover_" + index}
                    className=" hidden w-full bg-white divide-y divide-gray-200 rounded-lg shadow-lg group-hover:block"
                  >
                    <ul
                      className="py-1 text-gray-700 dark:text-gray-200"
                      aria-labelledby={"dropdownHoverButton_" + index}
                    >
                      {item?.sub_menu?.map((sub_item, index2) => (
                        <li key={index2}>
                          <a
                            href={
                              websiteUrl +
                              (sub_item?.canonical_url
                                ? sub_item?.canonical_url.includes("www.")
                                  ? "https://www.mumbaitak.in"
                                  : sub_item?.canonical_url
                                : "")
                            }
                            onClick={() => {
                              let eventName = `HamburgerMenu - ${item?.title} - ${sub_item.title} Click`;
                              sendGAEvent({
                                eventName: eventName,
                                pageTitle: document?.title,
                                pageLocation: window?.location?.href,
                              });
                              setIsDrawerOpen(false);
                            }}
                            className={`block px-4 py-2 mx-2 font-medium ${isMadhya
                              ? "hover:bg-[#e2f8f4]  "
                              : isRajasthan
                                ? "hover:bg-[#faf2e7]  "
                                : isHR
                                  ? "hover:bg-[#e8fce1]  "
                                  : isBH
                                    ? "hover:bg-[#ffe2f4]  "
                                    : isUP
                                      ? "hover:bg-[#feedeb]  "
                                      : isDL
                                        ? "hover:bg-[#fbd6d6]  "
                                        : isCGH
                                          ? "hover:bg-[#e0faf5]  "
                                          : isUK
                                            ? "hover:bg-[#e2f1fa]  "
                                            : isBiz ? "hover:bg-bizLight"
                                              : "hover:bg-primary-300  "
                              }`}
                          >
                            {sub_item?.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
      {/* <style>
        {`
       .vdo_floating {
          bottom: 80px !important;
        }
        `}
      </style> */}
    </>
  );
};

export default MobileNavbar;
